<template>
  <div
    class="aiz-carousel gutters-10 half-outside-arrow slick-initialized slick-slider"
  >
    <button class="slick-prev slick-arrow" type="button" @click="prev">
      <i class="las la-angle-left"></i>
    </button>

    <van-swipe
      ref="swipe"
      :autoplay="999999999"
      :loop="false"
      :show-indicators="false"
      :width="itemWidth"
    >
      <van-swipe-item v-for="(item, index) in list" :key="index">
        <div :style="`width: ${itemWidth}px`" class="slick-slide">
          <div>
            <div
              class="carousel-box"
              style="width: 100%; display: inline-block"
            >
              <ProductCard :item="item" />
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <button class="slick-next slick-arrow" type="button" @click="next">
      <i class="las la-angle-right"></i>
    </button>
  </div>
</template>
<script>
import ProductCard from "@/components/ProductCard.vue";
import { DeviceUtil } from "@/utils/deviceUtil";

export default {
  props: {
    list: Array,
  },
  data() {
    const itemWidth = DeviceUtil.isMobile() ? 174 : 217;
    return { itemWidth };
  },
  components: {
    ProductCard,
  },
  methods: {
    prev() {
      this.$refs.swipe.prev();
    },
    next() {
      this.$refs.swipe.next();
    },
  },
};
</script>
